import { EOrderStatus, EQuoteRequestVersionStatus } from '../configurations/order-status';

export class UiUtils {
  static getStatusIcon(currentStatus: string): string {
    if (!currentStatus) {
      return '';
    }

    let icon: string;
    switch (currentStatus.toLowerCase()) {
      case EOrderStatus.DECLINED:
      case EOrderStatus.CANCELED:
      case EQuoteRequestVersionStatus.CANCELED:
      case EQuoteRequestVersionStatus.EXPIRED:
      case EQuoteRequestVersionStatus.REJECTED:
      case EQuoteRequestVersionStatus.NOT_ORDERED:
        icon = 'close';
        break;
      case EOrderStatus.ISSUE:
      case EOrderStatus.PAYMENT_FAILED:
      case EOrderStatus.PAYMENT_CANCELED:
        icon = 'warning';
        break;
      default:
        icon = 'check';
    }

    return `icon-${icon} icon-${icon}__circle icon-check-styling`;
  }

  static singularOrPlural(value: number, translateKey: string): string {
    return value > 1 ? `${translateKey}-plural` : `${translateKey}-singular`;
  }

  static scrollToTop(): void {
    const scrollToTop: number = window.setInterval(() => {
      const pos: number = window.scrollY;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 5);
  }
}
